import { render, staticRenderFns } from "./FormShimmer.vue?vue&type=template&id=bacf3760&"
import script from "./FormShimmer.vue?vue&type=script&lang=js&"
export * from "./FormShimmer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports